import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

function NavPill({ id, onClick, active }) {
  return (
    <StyledNavPill
      className={`my-2 p-3 ${active ? 'is_active' : ''}`}
      onClick={() => {
        if (onClick) {
          onClick(id);
        }
      }}>
      <FormattedMessage id={id} />
    </StyledNavPill>
  );
}

export default NavPill;

const StyledNavPill = styled.div`
  background-color: #f0f0f0;
  color: #333;
  border-radius: 10px;
  cursor: pointer;
  :hover {
    background-color: #dbdbdb;
    color: #333;
  }
  &.is_active {
    background-color: #0d6efd;
    color: white;
  }
`;
